namespace TabAurous {
    import fld = Purchase.PurchaseItemsRow.Fields;

    export function GetConfigValue(Code: number): string {
        let value = "";
        Administration.ConfigurationService.List({ Code: Code }, response => {
            if (response.Entities != null && response.Entities.length > 0)
                value = response.Entities[0].Value;
            else
                value = "";
        }, { async: false });
        return value;
    }
    export function ValidateEditorFields(field, input: JQuery, text, oldText: string): number | boolean {
        let value: number;
        // *** Validate Decimal & Integer***
        if (field === fld.Weight || field === fld.Discount) {
            value = Q.parseDecimal(text);
            if (value == null || isNaN(value)) {
                Q.notifyError(Q.text('Validation.Decimal'), '', null);
                input.val(oldText);
                input.focus();
                return false;
            }
        }
        else if (field === fld.Pieces) {
            var i = Q.parseInteger(text);
            if (isNaN(i) || i > 32767 || i < 0) {
                Q.notifyError(Q.text('Validation.Integer'), '', null);
                input.val(oldText);
                input.focus();
                return false;
            }
            value = i;
        }
        else if (input.hasClass('numeric')) {
            var i = Q.parseInteger(text);
            if (isNaN(i) || i > 32767 || i < 0) {
                Q.notifyError(Q.text('Validation.Integer'), '', null);
                input.val(oldText);
                input.focus();
                return false;
            }
            value = i;
        }
        else {
            value = text;
        }
        return value;
    }

    export function ValidateTransaction(ItemDetails: Purchase.PurchaseItemsRow[], Pieces: number, Weight: number): boolean {
        let IsValid = true;
        if (ItemDetails.length == 0) {
            Q.alert("No Items added, At least add one entry. Can not Save! ")
            IsValid = false;
            return IsValid;
        }
        for (var i = 0; i < ItemDetails.length; i++) {
            let item = ItemDetails[i];
            if (item.HasBom) {
                item.BOMDetails.forEach(function (x) { 
                    if (x.ProductId == null || x.ProductId.toString() == "")
                        x.ProductId = item.ProductId;

                    if (isNaN(x.BomRate) || isNaN(x.BomAmount) || x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component(' + x.ProductCode + ') in ' + item.ProductCode + ', Can not Save! ');
                        Q.alert(msg)
                        IsValid = false;
                        return IsValid;
                    }
                })
            }
            if (IsValid) { 
                if (isNaN(item.UnitRate) || isNaN(item.GrossAmount) || item.UnitRate == null || item.UnitRate == 0 || item.GrossAmount == null || item.GrossAmount == 0) {
                    Q.alert("Rate not Defined for   " + item.ProductCode + ", Can not Save!")
                    IsValid = false;
                    return IsValid;
                }
            }
            if (IsValid)
                if (item.LaborDetails.length > 0) {
                    item.LaborDetails.forEach(function (x) {
                        if (isNaN(x.LabourRate) || isNaN(x.LabourAmount) || x.LabourRate == null || x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Labor Rate not Defined for (" + x.ProcessName + ") in " + item.ProductCode + ", Can not Save!")
                            IsValid = false;
                            return IsValid;
                        }
                    })
                }
        }
        return IsValid;
    }
}

